module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-plus-fill-e4721f5f.svg";